var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

import React, { useState, useEffect, useRef } from 'react';
import { Col, Row, Image, Form, Fade } from 'react-bootstrap';
import { useDispatch } from "react-redux";
import { ShowButtons, propertyTypeUpdate } from "../store/actions";
import { useSelector } from "react-redux";

import { UserSession } from 'usersession';

import imgSingleFamily from '../assets/Asset 4.jpg';
import imgCondo from '../assets/Asset 5.jpg';
import imgManufactured from '../assets/Asset 6.jpg';
import imgUnitsHome from '../assets/Asset 7.jpg';

var scrollToRef = function scrollToRef(ref) {
    return window.scrollTo(0, ref.current.offsetTop, { behavior: 'smooth' });
};
// General scroll to element function


export default function PropertyType() {
    var userSession = new UserSession();

    var _useState = useState(""),
        _useState2 = _slicedToArray(_useState, 2),
        propertyType = _useState2[0],
        setPropertyType = _useState2[1];

    var _useState3 = useState(""),
        _useState4 = _slicedToArray(_useState3, 2),
        unitsInput = _useState4[0],
        setUnitsInput = _useState4[1];

    var dispatch = useDispatch();
    var propertyTypeRedux = useSelector(function (state) {
        return state.nameReducer.propertyType;
    });

    var myRefProp = useRef(null);

    useEffect(function () {
        //This function scroll the slider into view
        !localStorage.getItem('doNotScroll') && scrollToRef(myRefProp);
    }, []);

    useEffect(function () {
        dispatch(ShowButtons(false));

        setPropertyType(propertyTypeRedux);

        userSession.setPropertyType(propertyTypeRedux);

        switch (propertyType) {
            case "DUPLEX":case "TRIPLEX":case "FOURPLEX":case "OVER FOUR":
                setUnitsInput("UNITS");break;
            // no default
        }

        if (propertyType.length > 0) dispatch(ShowButtons(true));
    }, [propertyType, unitsInput]);

    function handleUnitProp(value) {
        setUnitsInput(value);
    }

    function handleProperty(value) {
        setPropertyType(value);
        userSession.setPropertyType(value);
    }

    return React.createElement(
        React.Fragment,
        null,
        React.createElement(
            Form.Group,
            { className: 'mb-0' },
            React.createElement(
                Form.Row,
                { className: 'd-flex justify-content-center' },
                React.createElement(
                    Col,
                    { lg: 12, className: 'text-center mb-4' },
                    React.createElement(
                        'h2',
                        null,
                        'What is your property type?'
                    )
                ),
                React.createElement(
                    Col,
                    { ref: myRefProp, lg: 2, className: 'mb-4' },
                    React.createElement(
                        'div',
                        { className: 'overlay' },
                        React.createElement(Form.Check, {
                            type: 'radio',
                            inline: true,
                            id: 'sfrProperty',
                            value: 'SFR',
                            label: 'Single Family',
                            checked: propertyType === "SFR",
                            onChange: function onChange(e) {
                                handleProperty(e.target.value);
                                setUnitsInput("");
                                dispatch(propertyTypeUpdate(e.target.value));
                            } }),
                        React.createElement(Image, { src: imgSingleFamily, alt: 'Single family Home',
                            className: 'radImg2 rounded-circle radImg customShadow \n                                ' + (propertyType === "SFR" ? "d-none" : "") })
                    ),
                    React.createElement(
                        'h4',
                        null,
                        'Single Family'
                    )
                ),
                React.createElement(
                    Col,
                    { lg: 2, className: 'mb-4' },
                    React.createElement(
                        'div',
                        { className: 'overlay' },
                        React.createElement(Form.Check, {
                            type: 'radio',
                            inline: true,
                            id: 'condoProperty',
                            value: 'CONDO',
                            label: 'Condo',
                            checked: propertyType === "CONDO",
                            onChange: function onChange(e) {
                                handleProperty(e.target.value);
                                setUnitsInput("");
                                dispatch(propertyTypeUpdate(e.target.value));
                            } }),
                        React.createElement('img', { src: imgCondo, alt: 'Condo',
                            className: 'radImg2 rounded-circle radImg customShadow ' + (propertyType === "CONDO" ? "d-none" : "") })
                    ),
                    React.createElement(
                        'h4',
                        null,
                        'Condo'
                    )
                ),
                React.createElement(
                    Col,
                    { lg: 2, className: 'mb-4' },
                    React.createElement(
                        'div',
                        { className: 'overlay' },
                        React.createElement(Form.Check, {
                            type: 'radio',
                            inline: true,
                            id: 'manuProperty',
                            value: 'MANUFACTURED',
                            label: 'Manufactured Home',
                            checked: propertyType === "MANUFACTURED",
                            onChange: function onChange(e) {
                                handleProperty(e.target.value);
                                setUnitsInput("");
                                dispatch(propertyTypeUpdate(e.target.value));
                            } }),
                        React.createElement('img', { src: imgManufactured, alt: 'Manufactured Home',
                            className: 'radImg2 rounded-circle radImg customShadow ' + (propertyType === "MANUFACTURED" ? "d-none" : "") })
                    ),
                    React.createElement(
                        'h4',
                        null,
                        'Manufactured Home'
                    )
                ),
                React.createElement(
                    Col,
                    { lg: 2, className: '' },
                    React.createElement(
                        'div',
                        { className: 'overlay' },
                        React.createElement(Form.Check, {
                            type: 'radio',
                            inline: true,
                            id: 'unitsProperties',
                            value: 'UNITS',
                            label: 'Units Home',
                            checked: unitsInput === "UNITS",
                            onChange: function onChange(e) {
                                handleUnitProp(e.target.value);handleProperty("DUPLEX");dispatch(propertyTypeUpdate("DUPLEX"));
                            } }),
                        React.createElement('img', { src: imgUnitsHome, alt: 'Units Home',
                            className: 'radImg2 rounded-circle radImg customShadow ' + (unitsInput === "UNITS" ? "d-none" : "") })
                    ),
                    React.createElement(
                        'h4',
                        null,
                        'Units Home'
                    )
                )
            ),
            React.createElement(
                Fade,
                { 'in': unitsInput === "UNITS" },
                React.createElement(
                    Row,
                    { className: '' + (unitsInput !== "UNITS" ? "d-none" : "d-flex justify-content-center text-left pt-4") },
                    React.createElement(
                        Form.Group,
                        { className: 'mb-2', as: Col, lg: 4 },
                        React.createElement(
                            Form.Label,
                            { className: 'sr-only' },
                            'Units'
                        ),
                        React.createElement(
                            Form.Control,
                            { value: propertyType, onChange: function onChange(e) {
                                    handleProperty(e.target.value);dispatch(propertyTypeUpdate(e.target.value));
                                }, as: 'select', custom: true },
                            React.createElement(
                                'option',
                                { value: 'DUPLEX' },
                                'Duplex (2 UNITS)'
                            ),
                            React.createElement(
                                'option',
                                { value: 'TRIPLEX' },
                                'Triplex (3 UNITS)'
                            ),
                            React.createElement(
                                'option',
                                { value: 'FOURPLEX' },
                                'Quadplex (4 UNITS)'
                            )
                        )
                    )
                )
            )
        )
    );
}